import React from "react";
import "./InputComponent.scss"

const InputComponent = ({ value, onChange, placeholder, required, error, errorText, disable, type = "text" }) => {

    return (
        <div className="InputComponent-RewardsTick">
            <div className={`InputComponent-RewardsTick-container ${error ? "error" : disable ? "disable" : ""}`}>
                <input
                    className="InputComponent-RewardsTick-container-input"
                    value={value}
                    onChange={onChange}
                    type={type}
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {errorText !== "" && < div className="input-error-text">
                {errorText}
            </div>}
        </div >
    )
}
export default InputComponent
